module.exports = __webpack_public_path__ + "static/media/07B2.65ae6bf5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/robots/07B2.png
// module id = 273
// module chunks = 0